<script>
import AdditionalActions from "@/components/actions/AdditionalActions.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";
import BaseView from "@/mixins/BaseView.vue";

export default {
  name: "UserAdditionalActions",
  components: { AdditionalActions },
  mixins: [BaseView],
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ["change"],
  computed: {
    hasAccessToArchive() {
      return this.hasAccess(DispatcherPermissionValue.ArchiveUser);
    },
  },
  methods: {
    async archive(onSuccess, onError) {
      const resp = await this.$api.users.archiveUser(this.user.id);
      if (resp.success) {
        onSuccess();
        this.$emit("change");
      } else {
        onError("The user can’t be archived due to reasons:", resp.data?.detail);
      }
    },
    async unarchive(onSuccess, onError) {
      const resp = await this.$api.users.unarchiveUser(this.user.id);
      if (resp.success) {
        onSuccess();
        this.$emit("change");
      } else {
        onError("The user can’t be unarchived due to reasons:", resp.data?.detail);
      }
    },
  },
};
</script>

<template>
  <additional-actions
    :archive-confirmation-text="'Are you sure want to send ' + user.name + '’s account  to archive?'"
    :has-access="hasAccessToArchive"
    :is-archived="user.archived !== null"
    :permission-text="$t('permission.archive-user')"
    :unarchive-confirmation-text="'Are you sure want to return ' + user.name + '’s account from archive?'"
    archive-confirmation-title="Archive user"
    unarchive-confirmation-title="Unarchive user"
    @archive="archive"
    @unarchive="unarchive"
  ></additional-actions>
</template>

<style lang="scss" scoped></style>
